import { Component } from "@angular/core";
import { SharedComponents } from "../../../components/shared.module";
import { SmartTestStepperViewComponent } from "../../../components/smart-test-review/smart-test-stepper-view/smart-test-stepper-view.component";
import { TestReviewComponent } from "../../../components/smart-test-review/test-review/test-review.component";
import { BaseLayoutComponent } from "../../base-layout.component";
import { SmartTestReviewReportComponent } from "../../dashboard/smart-test-review-report/smart-test-review-report.component";

@Component({
  selector: "app-smart-test-review-manual",
  standalone: true,
  imports: [...SharedComponents],
  templateUrl: "./smart-test-review-manual.component.html",
  styleUrl: "./smart-test-review-manual.component.scss",
})
export class SmartTestReviewManualComponent extends BaseLayoutComponent {
  data: any = [
    {
      id: 1,
      title: "Upload SRS Document",
      dropDownLabel: "Select Upload Type",
      dropDownOptions: ["SRS", "BRD"],
      selectedOption: "SRS",
      uploadFile: {
        fileUploadLabel: "Upload SRD (or) BRD document",
        fileTypes: ".doc, .docx, .pdf",
        buttonLabel: "Choose file",
        placeholderText: "SRS (or) BRD files only",
      },
    },

    {
      id: 2,
      title: "Upload Test Case Document",
      dropDownLabel: "Select Versioning of Test Cases",
      dropDownOptions: ["version 1", "version 2", "version 3"],
      selectedOption:"version 1",
      infoUrl: "test",
    },
  ];

  tableData = {
    tableHeader: "Total no of Test Cases: ",
    data: [
      {
        test_case_id: "TC_US1_POS_01",
        test_case_title:
          "Verify successful single-click lead conversion and opportunity tab display.",
        test_case: [
          "Login as a sales representative.",
          "Navigate to the leads section.",
          "Select a qualified lead with all required fields populated.",
          "Click the Convert to Opportunity button (single-click conversion).",
          "Verify the presence of the Opportunity tab within the application.",
        ],
        expected_result: [
          "Streamline lead and opportunity management",
          "Leads section displays correctly.",
          "Selected lead details are displayed",
          "A new opportunity is created, pre- populated with lead’s information. A success message is displayed.",
          "The “Opportunity” tab is visible and accessible.",
        ],
        feedback: "adfasdfasfsd",
      },
      {
        test_case_id: "TC_US1_POS_01",
        test_case_title:
          "Verify successful single-click lead conversion and opportunity tab display.",
        test_case: [
          "Login as a sales representative.",
          "Navigate to the leads section.",
          "Select a qualified lead with all required fields populated.",
          "Click the Convert to Opportunity button (single-click conversion).",
          "Verify the presence of the Opportunity tab within the application.",
        ],
        expected_result: [
          "Streamline lead and opportunity management",
          "Leads section displays correctly.",
          "Selected lead details are displayed",
          "A new opportunity is created, pre- populated with lead’s information. A success message is displayed.",
          "The “Opportunity” tab is visible and accessible.",
        ],
        feedback: "",
      },
      {
        test_case_id: "TC_US1_POS_01",
        test_case_title:
          "Verify successful single-click lead conversion and opportunity tab display.",
        test_case: [
          "Login as a sales representative.",
          "Navigate to the leads section.",
          "Select a qualified lead with all required fields populated.",
          "Click the Convert to Opportunity button (single-click conversion).",
          "Verify the presence of the Opportunity tab within the application.",
        ],
        expected_result: [
          "Streamline lead and opportunity management",
          "Leads section displays correctly.",
          "Selected lead details are displayed",
          "A new opportunity is created, pre- populated with lead’s information. A success message is displayed.",
          "The “Opportunity” tab is visible and accessible.",
        ],
        feedback: "",
      },
      {
        test_case_id: "TC_US1_POS_01",
        test_case_title:
          "Verify successful single-click lead conversion and opportunity tab display.",
        test_case: [
          "Login as a sales representative.",
          "Navigate to the leads section.",
          "Select a qualified lead with all required fields populated.",
          "Click the Convert to Opportunity button (single-click conversion).",
          "Verify the presence of the Opportunity tab within the application.",
        ],
        expected_result: [
          "Streamline lead and opportunity management",
          "Leads section displays correctly.",
          "Selected lead details are displayed",
          "A new opportunity is created, pre- populated with lead’s information. A success message is displayed.",
          "The “Opportunity” tab is visible and accessible.",
        ],
        feedback: "",
      },
      {
        test_case_id: "TC_US1_POS_01",
        test_case_title:
          "Verify successful single-click lead conversion and opportunity tab display.",
        test_case: [
          "Login as a sales representative.",
          "Navigate to the leads section.",
          "Select a qualified lead with all required fields populated.",
          "Click the Convert to Opportunity button (single-click conversion).",
          "Verify the presence of the Opportunity tab within the application.",
        ],
        expected_result: [
          "Streamline lead and opportunity management",
          "Leads section displays correctly.",
          "Selected lead details are displayed",
          "A new opportunity is created, pre- populated with lead’s information. A success message is displayed.",
          "The “Opportunity” tab is visible and accessible.",
        ],
        feedback: "",
      },
      {
        test_case_id: "TC_US1_POS_01",
        test_case_title:
          "Verify successful single-click lead conversion and opportunity tab display.",
        test_case: [
          "Login as a sales representative.",
          "Navigate to the leads section.",
          "Select a qualified lead with all required fields populated.",
          "Click the Convert to Opportunity button (single-click conversion).",
          "Verify the presence of the Opportunity tab within the application.",
        ],
        expected_result: [
          "Streamline lead and opportunity management",
          "Leads section displays correctly.",
          "Selected lead details are displayed",
          "A new opportunity is created, pre- populated with lead’s information. A success message is displayed.",
          "The “Opportunity” tab is visible and accessible.",
        ],
        feedback: "",
      },
      {
        test_case_id: "TC_US1_POS_01",
        test_case_title:
          "Verify successful single-click lead conversion and opportunity tab display.",
        test_case: [
          "Login as a sales representative.",
          "Navigate to the leads section.",
          "Select a qualified lead with all required fields populated.",
          "Click the Convert to Opportunity button (single-click conversion).",
          "Verify the presence of the Opportunity tab within the application.",
        ],
        expected_result: [
          "Streamline lead and opportunity management",
          "Leads section displays correctly.",
          "Selected lead details are displayed",
          "A new opportunity is created, pre- populated with lead’s information. A success message is displayed.",
          "The “Opportunity” tab is visible and accessible.",
        ],
        feedback: "",
      },
      {
        test_case_id: "TC_US1_POS_01",
        test_case_title:
          "Verify successful single-click lead conversion and opportunity tab display.",
        test_case: [
          "Login as a sales representative.",
          "Navigate to the leads section.",
          "Select a qualified lead with all required fields populated.",
          "Click the Convert to Opportunity button (single-click conversion).",
          "Verify the presence of the Opportunity tab within the application.",
        ],
        expected_result: [
          "Streamline lead and opportunity management",
          "Leads section displays correctly.",
          "Selected lead details are displayed",
          "A new opportunity is created, pre- populated with lead’s information. A success message is displayed.",
          "The “Opportunity” tab is visible and accessible.",
        ],
        feedback: "",
      },
    ],
    columns: [
      {
        display_name: "Test Case Id",
        key: "test_case_id",
        headerStyles: {
          background: "#7593F2",
          color: "#FFFFFF",
          width: "5%",
          "font-weight": 600,
        },
      },
      {
        display_name: "Test Case Title",
        key: "test_case_title",
        headerStyles: {
          background: "#7593F2",
          color: "#FFFFFF",
          "font-weight": 600,
        },
      },
      {
        display_name: "Test Case",
        key: "test_case",
        type: "orderd-list",
        headerStyles: {
          background: "#7593F2",
          color: "#FFFFFF",
          "font-weight": 600,
        },
      },
      {
        display_name: "Expected Results",
        key: "expected_result",
        type: "orderd-list",
        headerStyles: {
          background: "#7593F2",
          color: "#FFFFFF",
          "font-weight": 600,
        },
      },
    ],
  };

  testReviewData = [
    {
      id: 1,
      description:
        "As a Project Manager, I want to create a new project, so that I can organize and manage tasks within a specific project context...",
      coverage: {
        positive_scenario: 70,
        negative_scenario: 60,
        boundary_value_analysis: 100,
        error_handling: 100,
        chart_data: 81,
      },

      weightage: {
        positive_scenario: 70,
        negative_scenario: 60,
        boundary_value_analysis: 100,
        error_handling: 100,
      },
      review_comments: {
        spell_check: "Poor",
        positive_scenario: `The positive scenarios test cases cover the basic functionality of creating a new project and tasks with different attribute such as title, description, due date, priority 
        and tem assignment.
        Ensure to include test cases for verifying successful creation of projects and tasks with valid input data.
        Check if the test cases cover the validation of mandatory fields during project and task creation.
        Consider adding test cases to confirm the successful assignment of tasks to team members within a project.
        Validate that projects and tasks are displayed correctly on the interface after creation.
        Include test cases to verify that deadlines can be successfully set for tasks within a project.
        Ensure that the system allows for the creation of multiple projects and tasks without conflicts.
        Validate that creating projects and tasks does not`,
        negative_scenario: `Negative Scenario: 
        Ensure to include negative scenarios in the best test cases such as attempting to create a project with a duplicate name to test for proper error handling.
        Include test cases to validate the behavior hen creating a project with invalid or empty data inputs, such as a blank project name or missing required fields.
        Add test cases to check the response when the user does not have the necessary permissions to create a project, ensuring proper error messages are displayed.
        Test the system’s response when creating a project exceeds the maximum character limit for project names or descriptions to cover boundary value analysis.
        Include test cases to verify the system’s behavior when creation a project in offline mode or within intermittent
        Check error handling for cases where inputs exceed the maximum allowed lengths.`,
        error_handling: `Error Handling: 
        Test Case: Create a new project with valid inputs(positive scenario)
        Modify: Add a test case to validate the error handling when creating a project with duplicate project name to ensure proper feedback is provided to the user.
        
        Test Case: Create a new project with empty project name (negative scenario)
        Modify: Include additional test case to check error handling when creating a project with special characters in the project name, ensuring appropriate error message is 
        displayed.
        
        Test Case: Veriffy maximum project title length allowed (boundary value analysis)
        Modify: Consider adding a test case to validate error handling when attempting to create a project with a title exceeding the maximum character limit, and ensure a
        clear error message is displayed.
        
        Test Case: Create`,
      },
      show_details: true,
      details: {
        data: [
          {
            test_case_id: "1",
            test_name:
              "Create New Project",
            test_steps: 
            `User navigates to the projects page user clicks on the “Create New Project” button user fills out the “Project Name” field user selects a “Project Manager” from the drop-down list user selects a “Start Date” for the project ser selects an “End Date” for the project user clicks on the “Create Project” button`,
            expected_result: `The project page is displayed a “Create New Project” form is displayed the project name is displayed in the form the selected project manager is displayed in the form the selected start date is displayed in the form the selected end date is displayed in the form the project is created and displayed in the projects page`,
          },
          {
            test_case_id: "2",
            test_name:
              "Edit Project",
            test_steps: `User navigates to the projects page user clicks on the edit icon next to the project they want to edit user makes changes to the project details user clicks on the “Update Project” button`,
            expected_result: `The project page is displayed the “Edit Project” form is displayed the changes are refelected in the form the project is updated and displayed in the projects page`,
          },
          {
            test_case_id: "3",
            test_name:
              "Delete Project",
            test_steps:`User navigates to the projects page user clicks on the delete icon next to the project they want to delete user clicks on the “Yes” button`,
            expected_result: `The project page is displayed aa confirmation dialog is displayed the project is deleted and removed from the projects page`,
          },
        ],
        columns: [
          {
            display_name: "Test Case Id",
            key: "test_case_id",
            headerStyles: {
              background: "#7593F2",
              color: "#000000",
              width: "5%",
              "font-weight": 600,
            },
          },
          {
            display_name: "Test Name",
            key: "test_name",
            headerStyles: {
              background: "#7593F2",
              color: "#000000",
              width: "5%",
              "font-weight": 600,
            },
          },
          {
            display_name: "Test Steps",
            key: "test_steps",
            headerStyles: {
              background: "#7593F2",
              color: "#000000",
              width: "5%",
              "font-weight": 600,
            },
          },
          {
            display_name: "Expected Results",
            key: "expected_result",
            headerStyles: {
              background: "#7593F2",
              color: "#000000",
              width: "5%",
              "font-weight": 600,
            },
          },
        ],
      },
    },
    {
      id: 2,
      description:
        "As a Product Owner, I want to set priorities for tasks, so that the team knows which tasks are most critical to the project's success.",
    },
    {
      id: 3,
      description:
        "As a Scrum Master, I want to be notified when a task is overdue, so that I can address any delays and keep the project on schedule.",
    },
    {
      id: 4,
      description:
        "As a Team Member, I want to view all tasks assigned to me, so that I can prioritize my work and stay informed about my responsibilities.",
    },
    {
      id: 5,
      description:
        "As a Project Manager, I want to create a new project, so that I can organize and manage tasks within a specific project context...",
    },
    {
      id: 6,
      description:
        "As a Product Owner, I want to set priorities for tasks, so that the team knows which tasks are most critical to the project's success.",
    },
    {
      id: 7,
      description:
        "As a Scrum Master, I want to be notified when a task is overdue, so that I can address any delays and keep the project on schedule.",
    },
    {
      id: 8,
      description:
        "As a Team Member, I want to view all tasks assigned to me, so that I can prioritize my work and stay informed about my responsibilities.",
    },
    {
      id: 9,
      description:
        "As a Project Manager, I want to create a new project, so that I can organize and manage tasks within a specific project context...",
    },
    {
      id: 10,
      description:
        "As a Product Owner, I want to set priorities for tasks, so that the team knows which tasks are most critical to the project's success.",
    },
    {
      id: 11,
      description:
        "As a Scrum Master, I want to be notified when a task is overdue, so that I can address any delays and keep the project on schedule.",
    },
    {
      id: 12,
      description:
        "As a Team Member, I want to view all tasks assigned to me, so that I can prioritize my work and stay informed about my responsibilities.",
    },
    {
      id: 13,
      description:
        "As a Project Manager, I want to create a new project, so that I can organize and manage tasks within a specific project context...",
    },
    {
      id: 14,
      description:
        "As a Product Owner, I want to set priorities for tasks, so that the team knows which tasks are most critical to the project's success.",
    },
    {
      id: 15,
      description:
        "As a Scrum Master, I want to be notified when a task is overdue, so that I can address any delays and keep the project on schedule.",
    },
    {
      id: 16,
      description:
        "As a Team Member, I want to view all tasks assigned to me, so that I can prioritize my work and stay informed about my responsibilities.",
    },
  ];

  stepData: any[] = [
    {
      title: "Test Case Document",
      component: SmartTestStepperViewComponent,
      data: {
        display_name: "Upload Test Case Document",
        view: "uploadTestCaseDoc",
        data: this.data,
      }
    },
    {
      title: "User Stories Overview",
      component: SmartTestStepperViewComponent,
      data: {
        display_name: "User Stories Overview",
        view: "userStoriesOverview",
        tableData: this.tableData,
      }
    },
    {
      title: "Test Review",
      component: TestReviewComponent,
      data: {
        display_name: "Test Review",
        view: "testReview",
        dataSet: this.testReviewData,
      }
    },
    {
      title: "Dashboard",
      component: SmartTestReviewReportComponent,
      data: {
        display_name: "Dashboard",
        view: "dashboard",
        dataSet: this.testReviewData,
      }
    }
  ];
}
